import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';

const RiberaStep1 = ({ formData, onChange }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validaciones
        // Nombre y Apellido: solo letras y espacios
        if (name === 'nombreApellido' && !/^[a-zA-Z\u00C0-\u017F\s]*$/.test(value)) {
            return;
        }
        // Matrícula: solo números
        if (name === 'matricula' && !/^[0-9]*$/.test(value)) {
            return;
        }
        // Teléfono: solo números y espacios
        if (name === 'telefono' && !/^[0-9\s]*$/.test(value)) {
            return;
        }

        onChange({ ...formData, [name]: value });
    };

    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Paso 1: Datos del Profesional Actuante</h5>
            </Card.Header>
            <Card.Body>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Nombre y Apellido
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="nombreApellido"
                                    value={formData.nombreApellido || ''}
                                    onChange={handleChange}
                                    placeholder="Ingrese nombre completo"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Matrícula Profesional
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="matricula"
                                    value={formData.matricula || ''}
                                    onChange={handleChange}
                                    placeholder="Ej: 12345"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Colegio Profesional
                                </Form.Label>
                                <Form.Select
                                    name="colegioProfesional"
                                    value={formData.colegioProfesional || ''}
                                    onChange={handleChange}
                                >
                                    <option value="">Seleccione un colegio</option>
                                    <option value="agrimensores">Colegio de Agrimensores de Tucumán</option>
                                    <option value="ingenieros">Colegio de Ingenieros de Tucumán</option>
                                    <option value="arquitectos">Colegio de Arquitectos de Tucumán</option>
                                    <option value="otro">Otro</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Email
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email || ''}
                                    onChange={handleChange}
                                    placeholder="ejemplo@correo.com"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Teléfono
                                </Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="telefono"
                                    value={formData.telefono || ''}
                                    onChange={handleChange}
                                    placeholder="Ej: 381 1234567"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default RiberaStep1;
